module.exports = __webpack_public_path__ + "fontawesome-webfont.db812d8a70a4e88e8887.woff2";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/layout/fonts/fontawesome-webfont.woff2?v=4.5.0
// module id = ../../../../../resources/layout/fonts/fontawesome-webfont.woff2?v=4.5.0
// module chunks = styles